import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import RegistrationSteps from '../../common/components/RegistrationSteps';
import Child from './Child';
import Center from './Center';
import ClassCalendar from './ClassCalendar';
import ClassList from './ClassList';
import Confirm from './Confirm';
import IndividualConsultationClass from './IndividualConsultationClass';
import { updateSelectedCenter } from '../actions';
import { fetchPayment, PaymentTypes, PAYMENT_FETCH_REQUEST, PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE } from '../payments/actions';
import { getChild, hasSameAsParentChild } from '../reducer';
import { getActiveLanguage } from '../../languages/reducer';
import utils from '../../common/services/utils';

import {
	loadBookingOptions, unselectLesson, loadPaymentMethods, loadInstalmentPlans, createAndSelectChild,
	selectProgramItem, unselectProgramItem,
	selectChild, selectCenter, selectTerm, selectPaymentType, selectPaymentMethod, selectConsultationDate,
	saveBooking, saveIndividualConsultationBooking, joinWaitingList, initiatePayment, validateBookingOptions, resetBooking,
	applyPromoCode, removePromoCode,
	PAYMENT_START_REQUEST, PAYMENT_START_SUCCESS, PAYMENT_START_FAILURE,
	PAYMENT_CANCEL_SUCCESS,
	BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE,
	BOOKING_CREATE_REQUEST, BOOKING_CREATE_SUCCESS, BOOKING_CREATE_FAILURE,
	WAITING_LIST_JOIN_REQUEST, WAITING_LIST_JOIN_SUCCESS, WAITING_LIST_JOIN_FAILURE,
	APPLY_PROMO_CODE_REQUEST, APPLY_PROMO_CODE_SUCCESS, APPLY_PROMO_CODE_FAILURE,
	REMOVE_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_SUCCESS, REMOVE_PROMO_CODE_FAILURE
} from './actions';
import {
	loadTermsByCenter, loadGradesByCenter,
	loadLessons, loadIndividualConsultationSchedule, loadWeeklyProgram,
	SELECTED_CENTER_LESSONS_REQUEST, SELECTED_CENTER_LESSONS_SUCCESS, SELECTED_CENTER_LESSONS_FAILURE,
	INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST, INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS, INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE,
	SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST, SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS, SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE
} from '../common/actions';
import {
	loadAgeAppropriateGradesByCenterAndTerm, getAgeAppropriateGradesByChild,
	CHILDREN_GRADES_REQUEST, CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE
} from '../actions';
import { fetchMedicalInformation, updateMedicalInformation } from '../children/actions';
import { initPaymentMethod } from './paymentMethods/actions';
import queryString from 'query-string';
import { withNamespaces } from 'react-i18next';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';
import { getFormValues, change, clearSubmitErrors } from 'redux-form';

class Booking extends Component {
	constructor(props) {
		super(props);
		this.handleChildSettingsSubmit = this.handleChildSettingsSubmit.bind(this);
		this.handleUpdateChildMedicalInformation = this.handleUpdateChildMedicalInformation.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.handleTermSelect = this.handleTermSelect.bind(this);
		this.handleGradesSelect = this.handleGradesSelect.bind(this);
		this.handleWeekdaySelect = this.handleWeekdaySelect.bind(this);
		this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);
		this.handleIndividualConsultationScheduleFetch = this.handleIndividualConsultationScheduleFetch.bind(this);
		this.handleLessonSelect = this.handleLessonSelect.bind(this);
		this.handleLessonUnselect = this.handleLessonUnselect.bind(this);
		this.handleClassNavigateBack = this.handleClassNavigateBack.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);
		this.handleNewChildSelect = this.handleNewChildSelect.bind(this);
		this.handleProgramItemSelect = this.handleProgramItemSelect.bind(this);
		this.handleProgramItemUnselect = this.handleProgramItemUnselect.bind(this);
		this.handleStartDateSelect = this.handleStartDateSelect.bind(this);
		this.handlePaymentTypeSelect = this.handlePaymentTypeSelect.bind(this);
		this.handleConsultationDateSelect = this.handleConsultationDateSelect.bind(this);
		this.handleSaveBooking = this.handleSaveBooking.bind(this);
		this.handleConfirmBooking = this.handleConfirmBooking.bind(this);
		this.handleBookingOptionsValidate = this.handleBookingOptionsValidate.bind(this);
		this.handleJoinWaitingList = this.handleJoinWaitingList.bind(this);
		this.handleApplyPromoCode = this.handleApplyPromoCode.bind(this);
		this.handleRemovePromoCode = this.handleRemovePromoCode.bind(this);
		this.handleSelectPaymentMethod = this.handleSelectPaymentMethod.bind(this);
		this.steps = [
			{
				id: 2,
				name: 'child',
				render: () => {
					const { queryParams: { add, medical, reset }, franchisor, requireMedicalInformation, bookingOptions: { selectedChildId } } = this.props;
					const isAdd = add === 'true';
					const isMedical = medical === 'true';
					const isReset = reset === 'true';

					if (selectedChildId > 0 && !requireMedicalInformation && !isAdd) {
						return <Redirect to='./center' />;
					}

					if (selectedChildId > 0 && requireMedicalInformation && !isMedical && !isReset) {
						return <Redirect to='./child?medical=true' />;
					}

					return <Child mode={isMedical ? 'medicalInfo' : isAdd ? 'add' : 'select'}
						children={this.props.parent.children}
						selectedChild={selectedChildId > 0 ? getChild(this.props.parent, selectedChildId) : null}
						onSelectChild={this.handleChildSelect} onSelectNewChild={this.handleNewChildSelect}
						onAddChild={this.handleChildSettingsSubmit} genderTypes={this.props.genderTypes}
						requireChildLastName={franchisor.requireChildLastName}
						requireChildSchool={franchisor.requireChildSchool}
						enableParentSelfBooking={franchisor.enableParentSelfBooking}
						hasSameAsParentChild={hasSameAsParentChild(this.props.parent)}
						medicalInformation={this.props.medicalInformation}
						currentMedicalInfoFormValues={this.props.currentMedicalInfoFormValues}
						changeMedicalInfoFormValue={this.props.changeMedicalInfoFormValue}
						clearMedicalInfoFormErrors={this.props.clearMedicalInfoFormErrors}
						onUpdateMedicalInformation={this.handleUpdateChildMedicalInformation}
					//medicalInformationBackPath={'/booking/child?reset=true'}
					/>;
				}
			},
			{
				id: 3,
				name: 'center',
				render: () => {
					if (!this.props.bookingOptions.selectedChildId || this.props.bookingOptions.selectedChildId <= 0) {
						return <Redirect to='./child' />;
					}

					if ((!this.props.isIndividualConsultation && this.props.bookingOptions.programId) ||
						(this.props.isIndividualConsultation && this.props.bookingOptions.date)) {
						return <Redirect to='./class' />;
					}

					const { queryParams: { edit }, selectedCenter, parent: { city }, isIndividualConsultation } = this.props;
					const changeSelectedCenter = (isIndividualConsultation && (!selectedCenter || !selectedCenter.isIndividualConsultation)) || edit === 'true';
					return <Center centers={this.props.centers}
						cities={this.props.cities}
						selectedCenter={selectedCenter}
						parentCity={city}
						changeSelectedCenter={changeSelectedCenter}
						onSelect={this.handleCenterSelect}
						isIndividualConsultation={this.props.isIndividualConsultation}
					/>;
				}
			},
			{
				id: 4,
				name: 'class',
				render: () => {
					if (!this.props.bookingOptions.selectedChildId) {
						return <Redirect to='./child' />;
					}

					if (this.props.isIndividualConsultation) {
						return <IndividualConsultationClass
							selectedCenter={this.props.selectedCenter}
							schedule={this.props.individualConsultationSchedule}
							enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
							enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
							currentCurrency={this.props.currentCurrency}
							franchisorCurrency={this.props.franchisor.currency}
							children={this.props.parent.children}
							onCalendarNavigate={this.handleIndividualConsultationScheduleFetch}
							onSelectConsultationDate={this.handleConsultationDateSelect}
							onUnselectConsultationDate={this.handleLessonUnselect}
							onSaveBooking={this.handleSaveBooking}
							onNavigateBack={this.handleClassNavigateBack}
							bookingOptions={this.props.bookingOptions}
							calendarBlock={INDIVIDUAL_CONSULTATION_SCHEDULE_REQUEST}
							calendarUnblock={[INDIVIDUAL_CONSULTATION_SCHEDULE_SUCCESS, INDIVIDUAL_CONSULTATION_SCHEDULE_FAILURE]}
						/>;
					}

					const allowWorkshops = this.props.franchisor && this.props.franchisor.enableWorkshops && this.props.centers && this.props.centers.some(c => c.isWorkshops);
					if (this.props.isCalendarView) {
						return <ClassCalendar selectedCenter={this.props.selectedCenter}
							centers={this.props.centers}
							terms={this.props.terms}
							selectedTerm={this.props.selectedTerm}
							onSelectTerm={this.handleTermSelect}
							grades={this.props.grades}
							selectedGrades={this.state.selectedGrades}
							onSelectGrades={this.handleGradesSelect}
							children={this.props.parent.children}
							lessons={this.props.lessons}
							enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
							enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
							currentCurrency={this.props.currentCurrency}
							franchisorCurrency={this.props.franchisor.currency}
							selectedLesson={this.props.selectedLesson}
							onCalendarNavigate={this.handleCalendarNavigate}
							onSelectLesson={this.handleLessonSelect}
							onUnselectLesson={this.handleLessonUnselect}
							onSelectPaymentType={this.handlePaymentTypeSelect}
							onSaveBooking={this.handleSaveBooking}
							onSelectJoinWaitingList={this.handleJoinWaitingList}
							onNavigateBack={this.handleClassNavigateBack}
							bookingOptions={this.props.bookingOptions}
							calendarBlock={SELECTED_CENTER_LESSONS_REQUEST}
							calendarUnblock={[SELECTED_CENTER_LESSONS_SUCCESS, SELECTED_CENTER_LESSONS_FAILURE]}
							bookingOptionsBlock={[BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_CREATE_REQUEST, WAITING_LIST_JOIN_REQUEST]}
							bookingOptionsUnblock={[BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE, BOOKING_CREATE_SUCCESS, BOOKING_CREATE_FAILURE, WAITING_LIST_JOIN_SUCCESS, WAITING_LIST_JOIN_FAILURE]}
							childrenInfoBlock={CHILDREN_GRADES_REQUEST}
							childrenInfoUnblock={[CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE]}
							onValidateBookingOptions={this.handleBookingOptionsValidate}
							allowWorkshops={allowWorkshops}
							recommendNearbyCenters={this.props.franchisor.recommendNearbyCenters}
							distanceToNearbyCenters={this.props.franchisor.distanceToNearbyCenters}
							onSelectNearbyCenter={(centerId) => {
								this.handleLessonUnselect();
								this.handleCenterSelect(this.props.centers.find(c => c.id === centerId));
							}}
						/>;
					}

					return <ClassList selectedCenter={this.props.selectedCenter}
						centers={this.props.centers}
						terms={this.props.terms}
						selectedTerm={this.props.selectedTerm}
						onSelectTerm={this.handleTermSelect}
						grades={this.props.grades}
						selectedGrades={this.state.selectedGrades}
						onSelectGrades={this.handleGradesSelect}
						selectedWeekday={this.state.selectedWeekday}
						onSelectWeekday={this.handleWeekdaySelect}
						children={this.props.parent.children}
						weeklyProgram={this.props.weeklyProgram}
						selectedProgramItem={this.props.selectedProgramItem}
						currentUser={this.props.currentUser}
						onLoadWeeklyProgram={() => this.reloadWeeklyProgram()}
						onSelectProgramItem={this.handleProgramItemSelect}
						onUnselectProgramItem={this.handleProgramItemUnselect}
						onSelectStartDate={this.handleStartDateSelect}
						onSelectPaymentType={this.handlePaymentTypeSelect}
						onSaveBooking={this.handleSaveBooking}
						onSelectJoinWaitingList={this.handleJoinWaitingList}
						onNavigateBack={this.handleClassNavigateBack}
						bookingOptions={this.props.bookingOptions}
						timetableBlock={SELECTED_CENTER_WEEKLY_PROGRAM_REQUEST}
						timetableUnblock={[SELECTED_CENTER_WEEKLY_PROGRAM_SUCCESS, SELECTED_CENTER_WEEKLY_PROGRAM_FAILURE]}
						bookingOptionsBlock={[BOOKING_OPTIONS_FETCH_REQUEST, BOOKING_CREATE_REQUEST, WAITING_LIST_JOIN_REQUEST]}
						bookingOptionsUnblock={[BOOKING_OPTIONS_FETCH_SUCCESS, BOOKING_OPTIONS_FETCH_FAILURE, BOOKING_CREATE_SUCCESS, BOOKING_CREATE_FAILURE, WAITING_LIST_JOIN_SUCCESS, WAITING_LIST_JOIN_FAILURE]}
						childrenInfoBlock={CHILDREN_GRADES_REQUEST}
						childrenInfoUnblock={[CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE]}
						onValidateBookingOptions={this.handleBookingOptionsValidate}
						allowWorkshops={allowWorkshops}
						enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
						enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
						currentCurrency={this.props.currentCurrency}
						franchisorCurrency={this.props.franchisor.currency}
						paymentTypes={this.props.paymentTypes}
						recommendNearbyCenters={this.props.franchisor.recommendNearbyCenters}
						distanceToNearbyCenters={this.props.franchisor.distanceToNearbyCenters}
						onSelectNearbyCenter={(centerId) => {
							this.handleProgramItemUnselect();
							this.handleCenterSelect(this.props.centers.find(c => c.id === centerId));
						}}
					/>;
				}
			},
			{
				id: 5,
				name: 'confirm',
				render: () => {
					return <Confirm
						paymentMethods={this.props.bookingOptions.paymentMethods}
						paymentProcessors={this.props.paymentProcessors}
						instalmentPlans={this.props.bookingOptions.instalmentPlans}
						payment={this.props.payment}
						paymentType={this.props.isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson}
						requireConsentOnPayment={this.props.franchisor.requireConsentOnPayment}
						requireAdditionalConsentOnInstalmentPayment={this.props.franchisor.requireAdditionalConsentOnInstalmentPayment}
						additionalConsentOnInstalmentPayment={this.props.franchisor.additionalConsentOnInstalmentPayment}
						termsAndConditions={this.props.isIndividualConsultation ? this.props.franchisor.individualConsultationsTermsAndConditions : this.props.franchisor.termsAndConditions}
						onPaymentMethodInit={this.props.initPaymentMethod}
						onSelectPaymentMethod={this.handleSelectPaymentMethod}
						onApplyPromoCode={this.handleApplyPromoCode}
						onRemovePromoCode={this.handleRemovePromoCode}
						promoCodeErrorMessage={this.props.promoCodeErrorMessage}
						enableUserTimeZone={this.props.franchisor.enableUserTimeZone}
						enableCurrencyConversion={this.props.franchisor.enableCurrencyConversion}
						currentCurrency={this.props.currentCurrency}
						franchisorCurrency={this.props.franchisor.currency}
						enableAnnualSubscriptionInstalments={this.props.franchisor.enableAnnualSubscriptionInstalments}
						countryCode={this.props.franchisor.countryCode}
						onConfirm={this.handleConfirmBooking}
						errorMessage={this.props.paymentErrorMessage}
						cancellationReason={this.props.cancellationReason}
						block={[PAYMENT_START_REQUEST, APPLY_PROMO_CODE_REQUEST, REMOVE_PROMO_CODE_REQUEST, PAYMENT_FETCH_REQUEST]}
						unblock={[APPLY_PROMO_CODE_SUCCESS, APPLY_PROMO_CODE_FAILURE, REMOVE_PROMO_CODE_SUCCESS, REMOVE_PROMO_CODE_FAILURE,
							PAYMENT_FETCH_SUCCESS, PAYMENT_FETCH_FAILURE, PAYMENT_CANCEL_SUCCESS]} // do not unblock UI once payment is started, just wait for redirection to next page
					/>;
				}
			}];

		this.state = {
			selectedGrades: props.selectedGrade ? [props.selectedGrade] : [],
			selectedWeekday: null
		};
	}

	componentDidMount() {
		const {
			match,
			history,
			isIndividualConsultation,
			isCalendarView,
			fetchPayment,
			loadInstalmentPlans,
			selectedCenter,
			loadTermsByCenter,
			loadGradesByCenter,
			loadPaymentMethods,
			bookingOptions: { selectedChildId },
			queryParams: { reset },
			resetBooking
		} = this.props;

		if (reset === 'true') {
			resetBooking();
		}

		if ((match.params.step === 'center' || match.params.step === 'class') && !selectedChildId) {
			history.replace('child');
		}

		if (match.params.step === 'confirm') {
			const paymentId = Number(match.params.id);
			fetchPayment(paymentId, isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson);
			loadInstalmentPlans(paymentId);
		}

		if (selectedCenter) {
			// init data for selected center
			if (!isIndividualConsultation) {
				loadTermsByCenter(selectedCenter.id);
				loadGradesByCenter(selectedCenter.id);
				if (isCalendarView) {
					this.reloadLessonsData(selectedCenter);
				} else {
					this.reloadWeeklyProgram(selectedCenter);
				}
			} else {
				this.props.loadIndividualConsultationSchedule(selectedCenter.id, selectedChildId);
			}
			loadPaymentMethods(selectedCenter.id);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.selectedTerm.id !== nextProps.selectedTerm.id && nextProps.selectedCenter) {
			// reload lessons/program for selected term
			if (nextProps.isCalendarView) {
				this.reloadLessonsData(nextProps.selectedCenter, null, null, nextProps.selectedTerm.id);
			} else {
				this.reloadWeeklyProgram(nextProps.selectCenter, nextProps.selectedTerm.id);
			}
		}

		if (nextProps.selectedCenter &&
			(!this.props.selectedCenter || nextProps.selectedCenter.id !== this.props.selectedCenter.id)) {
			// load lessons when new center is selected
			if (nextProps.isIndividualConsultation) {
				// schedule is loaded in IndividualConsultationClass with correct dates for the selected center
				//if (nextProps.bookingOptions.selectedChildId) {
				//this.props.loadIndividualConsultationSchedule(nextProps.selectedCenter.id, nextProps.bookingOptions.selectedChildId);
				//}
			} else {
				this.props.loadTermsByCenter(nextProps.selectedCenter.id);
				this.props.loadGradesByCenter(nextProps.selectedCenter.id);
				if (nextProps.isCalendarView) {
					this.reloadLessonsData(nextProps.selectedCenter);
				} else {
					this.reloadWeeklyProgram(nextProps.selectedCenter);
				}
			}
			this.props.loadPaymentMethods(nextProps.selectedCenter.id);
		}

		// schedule is loaded in IndividualConsultationClass with correct dates for the selected center
		//if (!this.props.bookingOptions.selectedChildId && nextProps.bookingOptions.selectedChildId && nextProps.selectedCenter) {
		//	if (nextProps.isIndividualConsultation) {
		//		this.props.loadIndividualConsultationSchedule(nextProps.selectedCenter.id, nextProps.bookingOptions.selectedChildId);
		//	}
		//}

		if (!this.props.bookingOptions.selectedChildId && nextProps.bookingOptions.selectedChildId && nextProps.requireMedicalInformation) {
			this.props.fetchMedicalInformation(nextProps.bookingOptions.selectedChildId);
		}

		if (this.props.match.params.step !== 'confirm' && nextProps.match.params.step === 'confirm') {
			const paymentId = nextProps.match.params.id;
			this.props.fetchPayment(paymentId, nextProps.isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson);
			this.props.loadInstalmentPlans(paymentId);
		}

		if (this.props.queryParams.reset !== 'true' && nextProps.queryParams.reset === 'true') {
			this.props.resetBooking();
		}
	}

	reloadLessonsData(selectedCenter, from, to, termId) {
		const selectedTermId = termId || this.props.selectedTerm.id;
		if (selectedTermId) {
			// load program for selected center
			this.props.loadLessons(selectedCenter.id, selectedTermId, null, from, to, null, true);		// load lessons for all grades, only filter on display in Class
			this.props.loadAgeAppropriateGradesByCenterAndTerm(selectedCenter.id, selectedTermId);

			// load program for nearby centers
			if (this.props.franchisor.recommendNearbyCenters) {
				const closestCenters = utils.findClosestCenters(selectedCenter, this.props.centers, this.props.franchisor.distanceToNearbyCenters);
				closestCenters.forEach(center => {
					this.props.loadLessons(center.id, selectedTermId, null, from, to, null, false);
				});
			}
		}
	}

	reloadWeeklyProgram(selectedCenter, termId) {
		const selectedCenterId = (selectedCenter && selectedCenter.id) || (this.props.selectedCenter && this.props.selectedCenter.id);
		const selectedTermId = termId || this.props.selectedTerm.id;
		if (selectedCenterId && selectedTermId) {
			// load program for selected center
			this.props.loadWeeklyProgram(selectedCenterId, selectedTermId,
				null,			// load all grades, filter on display
				[1, 2, 3, 4], 	// load all lessons - normal, trial, makeup, single
				true);			// mark as selected center

			//this.props.loadAgeAppropriateGradesByCenterAndTerm(centerId, selectedTermId);

			// load program for closest centers
			if (this.props.franchisor.recommendNearbyCenters) {
				const closestCenters = utils.findClosestCenters(selectedCenter || this.props.selectedCenter, this.props.centers, this.props.franchisor.distanceToNearbyCenters);
				closestCenters.forEach(center => {
					this.props.loadWeeklyProgram(center.id, selectedTermId,
						null,			// load all grades, filter on display
						[1, 2, 3, 4], 	// load all lessons - normal, trial, makeup, single
						false);			// mark as not selected center
				});
			}
		}
	}

	handleChildSettingsSubmit(values) {
		this.props.createAndSelectChild(values, this.props.history);
	}

	handleUpdateChildMedicalInformation(values) {
		const { selectedChildId } = this.props.bookingOptions;
		if (selectedChildId > 0) {
			this.props.updateMedicalInformation(selectedChildId, values);
		}
	}

	handleCenterSelect(center) {
		this.props.selectCenter(center.id);
		this.props.loadTermsByCenter(center.id);
		this.props.loadGradesByCenter(center.id);
		this.props.updateSelectedCenter(center.id, this.props.history, true);
	}

	handleTermSelect(termId) {
		this.props.selectTerm(Number(termId));
	}

	handleGradesSelect(gradeIds) {
		this.setState({ selectedGrades: gradeIds.map(id => this.props.grades.find(x => x.id === id)).filter(x => !!x) });
	}

	handleWeekdaySelect(weekday) {
		this.setState({ selectedWeekday: weekday });
	}

	handleCalendarNavigate(from, to) {
		const { selectedCenter } = this.props;
		if (selectedCenter) {
			this.reloadLessonsData(selectedCenter, from, to);
		}
	}

	handleIndividualConsultationScheduleFetch(from, to) {
		if (this.props.selectedCenter) {
			this.props.loadIndividualConsultationSchedule(this.props.selectedCenter.id, this.props.bookingOptions.selectedChildId, from, to);
		}
	}

	handleLessonSelect(lesson, lessonType) {
		this.trackView(lesson);

		this.props.loadBookingOptions({
			programId: lesson.programId,
			date: lesson.start,
			childId: this.props.bookingOptions.selectedChildId,
			lessonType: this.props.bookingOptions.lessonType
		});
	}

	trackView({ grade, center, term }) {
		analyticsTracker.trackEvent('view_item', {
			items: [
				{
					item_id: grade.id,
					item_name: grade.name,
					item_brand: center.name,
					item_category: `${term.name}, ${term.schoolYear}`
				}
			]

		}, AnalyticsPlatforms.GoogleAnalytics);
	}

	handleLessonUnselect() {
		this.props.unselectLesson();
	}

	handleClassNavigateBack() {
		this.handleLessonUnselect();
		this.props.history.push('center?edit=true');
	}

	handleChildSelect(child) {
		this.props.selectChild(child.id);
		this.props.history.push('child');	// removes reset=true
	}

	handleNewChildSelect() {
		this.props.history.push('child?add=true');//&reset=true
	}

	handleProgramItemSelect(programItem) {
		this.trackView(programItem);

		this.props.selectProgramItem(programItem.id);
	}

	handleProgramItemUnselect() {
		this.props.unselectProgramItem();
	}

	handleStartDateSelect(date) {
		const { selectedProgramItem, bookingOptions: { selectedChildId, lessonType } } = this.props;

		if (selectedProgramItem) {
			this.props.loadBookingOptions({
				programId: selectedProgramItem.id,
				date,
				childId: selectedChildId,
				lessonType
			});
		}
	}

	handlePaymentTypeSelect({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength }) {
		this.props.selectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson, annualPaymentLength });
	}

	handleConsultationDateSelect(date) {
		this.props.selectConsultationDate(date);
	}

	handleSaveBooking() {
		const {
			franchisor,
			isIndividualConsultation,
			selectedCenter,
			bookingOptions: { programId, date, selectedChildId, selectedPaymentTypeId, isPrepaid, selectedPaymentMethodName, isBonusLesson, annualPaymentLength }
		} = this.props;

		const campaignTags = analyticsTracker.getCampaignTags(franchisor);

		if (isIndividualConsultation) {
			const consultationRequestData = {
				childId: selectedChildId,
				centerId: selectedCenter.id,
				consultationDate: date,
				paymentMethodName: selectedPaymentMethodName,
				campaignTags
			};
			this.props.saveIndividualConsultationBooking(consultationRequestData, this.props.history);
		} else {
			const bookingRequestData = {
				childId: selectedChildId,
				programId,
				startDate: date,
				paymentType: selectedPaymentTypeId,
				isPrepaid,
				paymentMethodName: selectedPaymentMethodName,
				isBonusLesson,
				annualPaymentLength,
				campaignTags
			};

			this.props.saveBooking(bookingRequestData, this.props.history);
		}
	}

	handleJoinWaitingList() {
		const {
			bookingOptions: { programId, date, selectedChildId }
		} = this.props;
		this.props.joinWaitingList({
			childId: selectedChildId,
			programId,
			startDate: date
		}, this.props.history);
	}

	handleApplyPromoCode(promoCode) {
		if (this.props.payment) {
			this.props.applyPromoCode({ paymentId: this.props.payment.id, promoCode, paymentType: this.props.isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson });
		}
	}

	handleRemovePromoCode(promoCode) {
		if (this.props.payment) {
			this.props.removePromoCode({ paymentId: this.props.payment.id, promoCode, paymentType: this.props.isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson });
		}
	}

	handleSelectPaymentMethod(paymentMethod, isInstalmentPayment, instalmentPlanTemplateId) {
		if (this.props.payment) {
			this.props.selectPaymentMethod({ paymentId: this.props.payment.id, paymentMethod, paymentType: this.props.isIndividualConsultation ? PaymentTypes.IndividualConsultation : PaymentTypes.Lesson, isInstalmentPayment, instalmentPlanTemplateId });
		}
	}

	handleConfirmBooking({ paymentMethod }) {
		if (this.props.payment) {
			this.props.initiatePayment({ paymentId: this.props.payment.id, paymentMethod }, this.props.history);
		}
	}

	handleBookingOptionsValidate() {
		const {
			franchisor,
			bookingOptions: { programId, date, lessonType, selectedChildId, selectedPaymentTypeId, isPrepaid, selectedPaymentMethodName, isBonusLesson, isSelectJoinWaitingList }
		} = this.props;

		const campaignTags = analyticsTracker.getCampaignTags(franchisor);

		const data = {
			programId,
			date,
			childId: selectedChildId,
			lessonType,
			paymentType: selectedPaymentTypeId,
			isPrepaid,
			paymentMethodName: selectedPaymentMethodName,
			isBonusLesson,
			isSelectJoinWaitingList,
			campaignTags
		};
		this.props.validateBookingOptions(data, this.props.history);
	}

	render() {
		const { match } = this.props;
		const currentStepName = match.params.step;
		let currentStep = currentStepName && this.steps.find(s => s.name === currentStepName);
		if (!currentStep) {
			currentStep = this.steps[0];
		}

		return (
			<div>
				<RegistrationSteps currentStep={currentStep.id} />
				<Row>
					<Col sm={12}>
						{currentStep.render()}
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		parent,
		entities: { centers, individualConsultationSchedule, grades, lessons, weeklyProgram, terms, payments, medicalInformations },
		lookups: { medicalInformationForm, paymentTypes },
		configuration: { franchisor },
		auth: { currentUser },
		paymentProcessors,
		booking
	} = state;

	const {
		termId,
		gradeId,
		programId,
		date,
		lessonType,
		upcomingLessons,
		selectedChildId,
		selectedPaymentTypeId,
		isPrepaid,
		selectedPaymentMethodName,
		isSelectJoinWaitingList,
		isBonusLesson,
		annualPaymentLength,
		warningMessage,
		errorMessage,
		childrenPaymentTypes,
		paymentMethodsByCenter,
		instalmentPlans,
		fetchingBookingOptions,
		cancellationReason,
		promoCodeErrorMessage,
		result
	} = state.booking;

	const isIndividualConsultation = ownProps.location.pathname.startsWith('/individual-consultation');
	const isCalendarView = franchisor.timetableViewType === 'Calendar';

	const paymentId = ownProps.match.params.step === 'confirm' && Number(ownProps.match.params.id);
	const savedPayment = paymentId && payments[paymentId];

	const selectedCenterId = (savedPayment && savedPayment.centerId) || booking.centerId || parent.centerId;	// booking.centerId is set in Dashboard forms
	const selectedCenter = centers[selectedCenterId];
	let selectedLesson = null, selectedProgramItem = null;

	const selectedCenterTerms = selectedCenter && selectedCenter.terms ?
		selectedCenter.terms
			.map(x => ({ ...terms[x.id], ...x }))	 // replace startDate and endDate with actual working period for the selected term
			.filter(x => x.allowBooking)
			.sort((a, b) => moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD'))
		: [];

	const selectedTerm = (termId ? selectedCenterTerms.find(x => x.id === termId) : selectedCenterTerms[0]) || { id: 0 };

	if (savedPayment) {
		savedPayment.parent = parent;
		savedPayment.child = getChild(parent, savedPayment.childId);

		if (savedPayment.lesson) {
			savedPayment.lesson.center = centers[savedPayment.lesson.centerId];
			savedPayment.lesson.term = selectedCenterTerms.find(x => x.id === savedPayment.lesson.termId);
			savedPayment.lesson.grade = grades[savedPayment.lesson.gradeId];
		}

		if (savedPayment.centerId) {
			savedPayment.center = centers[savedPayment.centerId];
		}
	}

	let individualConsultationScheduleForSelectedChildAndCenter = [], deepLoadedLessons = [], deepLoadedWeeklyProgram = [];

	if (isIndividualConsultation) {
		const scheduleFilter = (selectedCenterId && state.filters.individualConsultationScheduleByChildAndCenter[`${selectedChildId || 'all'}-${selectedCenterId}`]) || { ids: [], loading: false };
		individualConsultationScheduleForSelectedChildAndCenter = scheduleFilter.ids.map(id => individualConsultationSchedule[id]);
	} else {
		if (isCalendarView) {
			deepLoadedLessons = Object.values(lessons);
			// add full grade info in each lesson (not loaded through API)
			deepLoadedLessons.forEach(lesson => {
				lesson.grade = grades[lesson.gradeId] || { name: '', subGrades: [] };
				lesson.center = selectedCenter || { name: '' };
				lesson.term = selectedTerm || { name: '', schoolYear: '' };
			});

			selectedLesson = programId && lessons[`${programId}@${date}`];
			if (selectedLesson) {
				selectedLesson.grade = grades[selectedLesson.gradeId] || { name: '' };
				selectedLesson.center = centers[selectedLesson.centerId] || { name: '' };
				selectedLesson.term = selectedCenterTerms.find(x => x.id === selectedLesson.termId);
			}
		} else {
			deepLoadedWeeklyProgram = Object.values(weeklyProgram);
			deepLoadedWeeklyProgram.forEach(item => {
				item.grade = grades[item.gradeId] || { name: '', subGrades: [] };
				item.center = centers[item.centerId] || { name: '' };
				item.term = selectedCenterTerms.find(x => x.id === item.termId) || { name: '', schoolYear: '' };
			});

			selectedProgramItem = programId && weeklyProgram[programId];
			if (selectedProgramItem) {
				selectedProgramItem.grade = grades[selectedProgramItem.gradeId] || { name: '', subGrades: [] };
				selectedProgramItem.center = centers[selectedProgramItem.centerId] || { name: '' };
				selectedProgramItem.term = selectedCenterTerms.find(x => x.id === selectedProgramItem.termId) || { name: '', schoolYear: '' };
			}
		}
	}

	// populate age appropriate grades according to selected center and term
	parent.children.forEach(child => {
		let ageAppropriateGradeIds = child.ageAppropriateGradeIds || [];
		if (selectedCenter && selectedTerm) {
			ageAppropriateGradeIds = getAgeAppropriateGradesByChild(parent, selectedCenter.id, selectedTerm.id, child.id) || [];
		}

		child.ageAppropriateGrades = ageAppropriateGradeIds.map(gradeId => grades[gradeId]);
	});

	const requireMedicalInformation = selectedChildId && franchisor.requireMedicalInformation && !medicalInformations[selectedChildId];
	const medicalInformation = medicalInformations[selectedChildId] || (medicalInformationForm && {
		id: 0,
		formId: medicalInformationForm.id,
		childId: selectedChildId,
		name: medicalInformationForm.name,
		content: {}
	});

	const queryParams = queryString.parse(ownProps.location.search);
	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		franchisor,
		grades: selectedCenter && selectedCenter.grades ?
			selectedCenter.grades.map(id => grades[id]).filter(x => !!x) : [],
		selectedGrade: gradeId && grades[gradeId],  // single grade selected in Dashboard booking form
		parent,
		isIndividualConsultation,
		isCalendarView,
		genderTypes: state.lookups.genderTypes,
		selectedCenter,
		selectedTerm,
		cities: [...new Set(Object.values(centers).map(center => center.city))],	// distinct list of cities with centers
		centers: Object.values(centers),
		lessons: deepLoadedLessons,
		selectedLesson,
		weeklyProgram: deepLoadedWeeklyProgram,
		selectedProgramItem,
		individualConsultationSchedule: individualConsultationScheduleForSelectedChildAndCenter,
		terms: selectedCenterTerms,
		bookingOptions: {
			programId,
			date,
			lessonType,
			upcomingLessons,
			selectedChildId,
			selectedPaymentTypeId,
			isPrepaid,
			selectedPaymentMethodName,
			isSelectJoinWaitingList,
			isBonusLesson,
			annualPaymentLength,
			warningMessage,
			errorMessage,
			childrenPaymentTypes: childrenPaymentTypes.map(c => ({
				child: getChild(state.parent, c.childId),
				paymentTypes: c.paymentTypes,
				errorMessage: c.errorMessage,
				joinWaitingList: c.joinWaitingList,
				isLocked: c.isLocked
			})),
			paymentMethods: paymentMethodsByCenter[selectedCenterId] ? paymentMethodsByCenter[selectedCenterId] : [],
			instalmentPlans
		},
		paymentProcessors,
		payment: savedPayment,
		fetchingBookingOptions,
		promoCodeErrorMessage,
		cancellationReason,
		paymentErrorMessage: result && result.errorMessage,
		queryParams,
		currentUser,
		requireMedicalInformation,
		medicalInformation,
		currentMedicalInfoFormValues: getFormValues('customForm')(state),
		currentCurrency: activeLanguage && activeLanguage.currencyCode,
		paymentTypes
	};
};

export default connect(mapStateToProps, {
	updateSelectedCenter,
	loadTermsByCenter,
	loadGradesByCenter,
	loadLessons,
	loadIndividualConsultationSchedule,
	loadWeeklyProgram,
	selectProgramItem,
	unselectProgramItem,
	loadAgeAppropriateGradesByCenterAndTerm,
	loadBookingOptions,
	unselectLesson,
	loadPaymentMethods,
	loadInstalmentPlans,
	createAndSelectChild,
	selectChild,
	selectCenter,
	selectTerm,
	selectPaymentType,
	selectPaymentMethod,
	selectConsultationDate,
	saveBooking,
	saveIndividualConsultationBooking,
	joinWaitingList,
	fetchPayment,
	initPaymentMethod,
	initiatePayment,
	validateBookingOptions,
	resetBooking,
	applyPromoCode,
	removePromoCode,
	fetchMedicalInformation,
	updateMedicalInformation,
	changeMedicalInfoFormValue: (field, value) => change('customForm', field, value),
	clearMedicalInfoFormErrors: () => clearSubmitErrors('customForm')
})(withNamespaces()(Booking));